import { useOnErrorScreen } from "@magalu/ravejs-platform-hooks/services";

import { getTracer } from "../utils/tracer";

const sendToAppErrorScreen = async (
  _ctx: unknown,
  props: { notFound: boolean; errorCode: number },
  _args: unknown
) => {
  const tracer = getTracer("sendToAppErrorScreen");

  if (props?.errorCode === 500) {
    const span = tracer.startSpan("sendToAppErrorScreen.500");

    try {
      useOnErrorScreen({ errorCode: 500 }, console);
      const error = new Error("Internal Server Error") as Error & {
        fromSendToAppErrorScreen: boolean;
      };
      error.fromSendToAppErrorScreen = true;

      span.setAttributes({
        error: true,
        errorCode: 500,
        message: error.message,
      });
      span.recordException(error);
      span.end();

      throw error;
    } catch (error) {
      span.setAttributes({
        error: true,
        errorCode: 500,
      });
      span.recordException(error as Error);
      span.end();
      throw error;
    }
  }

  if (props?.notFound) {
    const span = tracer.startSpan("sendToAppErrorScreen.404");

    try {
      useOnErrorScreen(
        {
          errorCode: 404,
          message:
            "Mas, espera 🤔. É só fazer uma nova busca, ou então voltar para a página inicial e continuar navegando!",
          title: "Oops! Essa página não está por aqui",
        },
        console
      );
      const error = new Error("Not Found") as Error & {
        fromSendToAppErrorScreen: boolean;
      };
      error.fromSendToAppErrorScreen = true;

      span.setAttributes({
        error: true,
        errorCode: 404,
        message: error.message,
      });
      span.recordException(error);
      span.end();

      throw error;
    } catch (error) {
      span.setAttributes({
        error: true,
        errorCode: 404,
      });
      span.recordException(error as Error);
      span.end();
      throw error;
    }
  }
};

export default sendToAppErrorScreen;
